var _path, _g, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCondFollowup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_435_467",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.525504 0H7.82177C7.99477 0 8.13501 0.136185 8.13501 0.304177V5.67629C8.13501 5.84428 7.99477 5.98046 7.82177 5.98046H0.525504C0.352504 5.98046 0.21226 5.84428 0.21226 5.67629V0.304177C0.21226 0.136185 0.352504 0 0.525504 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_435_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.525504 0H7.82177C7.99477 0 8.13501 0.136185 8.13501 0.304177V5.67629C8.13501 5.84428 7.99477 5.98046 7.82177 5.98046H0.525504C0.352504 5.98046 0.21226 5.84428 0.21226 5.67629V0.304177C0.21226 0.136185 0.352504 0 0.525504 0Z",
    stroke: "#212529",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5412 8.75366H4.323V6.83032",
    stroke: "#212529",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68506 8.9325V13.1029H10.5871",
    stroke: "#212529",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1553 9.57761C13.739 9.57761 14.2122 9.11812 14.2122 8.55132C14.2122 7.98451 13.739 7.52502 13.1553 7.52502C12.5716 7.52502 12.0984 7.98451 12.0984 8.55132C12.0984 9.11812 12.5716 9.57761 13.1553 9.57761Z",
    fill: "#212529",
    stroke: "#212529"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1553 14C13.739 14 14.2122 13.5405 14.2122 12.9737C14.2122 12.4069 13.739 11.9474 13.1553 11.9474C12.5716 11.9474 12.0984 12.4069 12.0984 12.9737C12.0984 13.5405 12.5716 14 13.1553 14Z",
    fill: "#212529",
    stroke: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondFollowup);
export default __webpack_public_path__ + "static/media/cond-followup.a8099d61da6eac0dd3098975ab1ec851.svg";
export { ForwardRef as ReactComponent };